import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import BaseTagPicker, { BaseTagPickerProps } from './BaseTagPicker'
import { useTranslation } from 'react-i18next'

export type EnumPickerLabel = {
    name: string
    disabled: boolean
}

export type EnumPickerProps<T> = Partial<BaseTagPickerProps<T>> &
    Required<Pick<BaseTagPickerProps<T>, 'selectedOptions' | 'onOptionsSelect'>> & {
        options: T[]
        labels: Map<T, EnumPickerLabel>
    }

export default function EnumPicker<T>(props: EnumPickerProps<T>): ReactElement {
    const { t: translate } = useTranslation()

    const renderedLabels = useMemo(
        () =>
            new Map<T, EnumPickerLabel>(
                [...props.labels].map(
                    option => [option[0], { name: translate(option[1].name), disabled: option[1].disabled }] as const,
                ),
            ),
        [],
    )

    return (
        <BaseTagPicker<T>
            filter={entity =>
                !renderedLabels.get(entity).disabled || props.selectedOptions?.some(id => id === entity.toString())
            }
            entities={props.options}
            getEntityValue={value => value.toString()}
            getEntityTagLabel={value => renderedLabels.get(value).name}
            getEntityLabel={value => renderedLabels.get(value).name}
            {...props}
        />
    )
}
